<template>
  <div id="step2" class="step2">
    <p class="step2__text1">
      {{
        radioResult
      }}での受取可能な日時です。日付をクリック（タップ）してください。
    </p>
    <!-- <div class="city_plaza_rest_info">
      リニューアルに伴いシティプラザ店は4月1日(土)〜7月初旬(予定)の期間休業いたします。<br />
      お客様には大変ご迷惑をお掛け致しますが、何卒ご理解いただきますようお願い申し上げます。
    </div> -->
    <div class="calendar">
      <!-- <p class="step2__text1" style="color: red">
        12月23日（金）、12月24日（土）のご予約分は終了いたしました。
      </p> -->
      <div id="calendar-nav">
        <p class="w-100 text-center">
          <span
            @click="moveLastMonth()"
            v-if="calPrevBtn"
            class="monthBtn monthBtn_left"
          >
            {{
              getYearName(calData.year, getMonthName(calData.month), "prev")
            }}年{{ getMonthName(calData.month - 1, "prev") }}月
          </span>
          <span class="m-auto text-center currentMonth">
            {{ calData.year }}年{{ getMonthName(calData.month) }}月
          </span>
          <span
            @click="moveNextMonth()"
            v-if="calNextBtn"
            class="monthBtn monthBtn_right"
          >
            {{
              getYearName(calData.year, getMonthName(calData.month), "next")
            }}年{{ getMonthName(calData.month + 1, "next") }}月
          </span>
        </p>
      </div>
      <table id="calendar">
        <thead>
          <tr>
            <th v-for="(week, index) in weeks" :key="index">{{ week }}</th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr v-for="(week, index) in calendar" :key="index">
            <td
              v-for="(day, index) in week"
              :key="index"
              @click="openModal(day.day)"
              :id="['td-' + day.day]"
              :class="{
                visited: day.visited,
                today: day.today,
              }"
            >
              <span class="day">{{ day.day }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal" id="modal">
      <div id="modal--whiteBlock">
        <div id="modal--content">
          <p class="stopButton" id="stopButton" @click="closeModal">
            <i class="fas fa-times"></i>
          </p>

          <div class="selectDate">
            <span>12月{{ reservation.date }}日</span>
            のお受け取り
          </div>
          <p class="text-center pt-5">受け取り時間を指定してください</p>
          <div class="selectTime">
            <select
              name="time1"
              class="selectTime__select selectTime__select_1"
              v-model="selectHour"
              @change="readMin"
            >
              <option
                v-for="(hour, index) in reserveTime.hour"
                :value="hour"
                :key="index"
              >
                {{ hour }}
              </option>
            </select>
            :
            <select
              name="time2"
              class="selectTime__select selectTime__select_2"
              v-model="selectMin"
            >
              <option
                v-for="(min, index) in reserveTime.min"
                :value="min"
                :key="index"
              >
                {{ min }}
              </option>
            </select>
            ごろ
          </div>
          <p
            class="btn"
            @click="
              showItemList();
              next();
            "
          >
            商品選択へすすむ<i class="fas fa-chevron-right"></i>
          </p>
        </div>
      </div>
    </div>

    <p class="reverse">
      <span class="a" @click="prev(1)"
        ><i class="fas fa-chevron-left"></i>受取店舗選択へもどる</span
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "step2",
  props: [
    "buttonText",
    "step",
    "shops",
    "radioResult",
    "weeks",
    "calData",
    "reservation",
  ],
  data() {
    return {
      thisDate: new Date("2024/12/01"),
      reserveTime: {
        hour: [],
        min: [],
      },
      selectHour: "",
      selectMin: "",
      currentDate: "",
      currentTime: {
        open: {
          time: "",
          hour: "",
          min: "",
        },
        close: {
          time: "",
          hour: "",
          min: "",
        },
      },
      calPrevBtn: false,
      calNextBtn: true,
    };
  },
  mounted() {
    this.calData.year = this.thisDate.getFullYear();
    this.calData.month = this.thisDate.getMonth() + 1;
    this.calData.date = this.thisDate.getDate();

    this.showCalBtn();

    const pageHeaderCartBtn = document.getElementById("pageHeaderCartBtn");
    pageHeaderCartBtn.style.display = "none";
    const pageHeaderCartBtn_first = document.getElementById(
      "pageHeaderCartBtn_first"
    );
    pageHeaderCartBtn_first.style.display = "block";
  },
  methods: {
    filterGray(input, arr) {
      return arr.includes(input);
    },

    //アイテムリストの選別
    showItemList: function() {
      this.$emit("showItemList");
    },
    next: function() {
      this.$emit("next");
    },
    prev: function(number) {
      this.$emit("prev", number);
    },
    openModal: function(day) {
      // クリックしたTDのIDを代入
      let reservationDate = document.getElementById("td-" + day);
      // そのテキスト（日付）がはいる
      let reservationDateText = document.getElementById("td-" + day)
        .textContent;
      // 表示用の月・日
      let dispMonth, dispDay;

      // グレーアウトしているかどうか
      if (
        reservationDateText !== "" &&
        !reservationDate.classList.contains("visited")
      ) {
        // グレーアウトしていないばあいのみ処理
        this.reservation.date = reservationDateText;
        this.reservation.year = this.calData.year;
        this.reservation.month = this.calData.month;

        //-----------------------------
        // 受け取り時間セレクトボックス生成
        //-----------------------------

        // セレクトボックスリセット
        this.reserveTime.hour = [];
        this.reserveTime.min = [];

        dispMonth = this.getMonthName(this.calData.month);
        dispDay = reservationDateText;
        // 9 -> 09 などに整形してcurrentDateに代入（1月10日なら「0110」のような形式にするため）
        if (dispMonth < 10) {
          dispMonth = "0" + dispMonth;
        }
        if (dispDay < 10) {
          dispDay = "0" + dispDay;
        }
        this.currentDate = dispMonth + dispDay;
        // 各開店・閉店時間を取得
        eval(
          "this.currentTime.open.time = this.reservation.store.opening_hours.open_time_date" +
            this.currentDate +
            ";"
        );
        eval(
          "this.currentTime.close.time = this.reservation.store.opening_hours.close_time_date" +
            this.currentDate +
            ";"
        );

        // 時間の1022（10時22分）などを10と22（時と分）に分ける
        // 開店
        this.currentTime.open.hour = parseInt(
          this.currentTime.open.time.slice(0, 2),
          10
        );
        this.currentTime.open.min = this.currentTime.open.time.slice(2, 4);
        // 閉店
        this.currentTime.close.hour = parseInt(
          this.currentTime.close.time.slice(0, 2),
          10
        );
        this.currentTime.close.min = this.currentTime.close.time.slice(2, 4);

        // 時を設定
        for (
          let i = this.currentTime.open.hour;
          i <= this.currentTime.close.hour;
          i++
        ) {
          this.reserveTime.hour.push(i);
        }
        // 時の初期値
        this.selectHour = this.currentTime.open.hour;

        // 分を設定
        this.readMin();

        // 分の初期値
        this.selectMin = this.currentTime.open.min;

        //--------------------------
        // モーダルウィンドウを開く処理
        //--------------------------
        let dateBlock = document.getElementById("modal");
        dateBlock.style.display = "block";
      }
      let reserDate =
        this.reservation.year +
        "/" +
        this.reservation.month +
        "/" +
        this.reservation.date;
      let reserDate_dt = new Date(reserDate);
      let reserDayWeek = reserDate_dt.getDay() + 1;
      this.reservation.dayOfWeek = this.weeks[reserDayWeek];
    },
    // 時間を計測
    readMin: function() {
      // 選択した'時'　が open の'時'だったら　かつ
      // open の 分　が30だったら
      if (
        this.selectHour == this.currentTime.open.hour &&
        this.currentTime.open.min == "30"
      ) {
        this.reserveTime.min = ["30"];
        this.selectMin = "30";
        // 選択した'時'　が close の'時'だったら かつ
        // open の 分　が000だったら
      } else if (
        this.selectHour == this.currentTime.close.hour &&
        this.currentTime.close.min == "00"
      ) {
        this.reserveTime.min = ["00"];
        this.selectMin = "00";
      } else {
        this.reserveTime.min = ["00", "30"];
      }
    },
    closeModal: function() {
      let dateBlock = document.getElementById("modal");
      dateBlock.style.display = "none";
    },

    ////////////////////////////////////////////////////////////////////
    //ボタン(カレンダー上部の)の年月の処理
    getYearName: function(year, month, status) {
      if (month === 1 && status === "prev") {
        return year - 1;
      } else if (month === 12 && status === "next") {
        return year + 1;
      } else {
        return year;
      }
    },
    getMonthName: function(month, status) {
      let monthName = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      if (month === 0 && status === "prev") {
        return 12;
      } else if (month === 13 && status === "next") {
        return 1;
      }
      return monthName[month - 1];
    },
    ////////////////////////////////////////////////////////////////////

    // カレンダーの月移動
    moveLastMonth: function() {
      if (this.calData.month == 1) {
        this.calData.year--;
        this.calData.month = 12;
      } else {
        this.calData.month--;
      }
      this.showCalBtn();
    },
    moveNextMonth: function() {
      if (this.calData.month == 12) {
        this.calData.year++;
        this.calData.month = 1;
      } else {
        this.calData.month++;
      }
      this.showCalBtn();
    },
    showCalBtn: function() {
      //prev
      if (this.calData.month == this.thisDate.getMonth() + 1) {
        // 今月の場合
        this.calPrevBtn = false;
      } else {
        this.calPrevBtn = true;
      }

      //next
      if (this.calData.month == this.thisDate.getMonth() + 3) {
        // さ来月だったら (今月が1~10月の場合)
        this.calNextBtn = false;
      } else if (this.calData.year !== this.thisDate.getFullYear()) {
        //年をまたぐ場合
        if (this.thisDate.getMonth() + 1 === 11 && this.calData.month === 1) {
          this.calNextBtn = false;
        }
        if (this.thisDate.getMonth() + 1 === 12 && this.calData.month === 2) {
          this.calNextBtn = false;
        }
      } else {
        this.calNextBtn = true;
      }
    },
  },
  computed: {
    calendar: function() {
      // 1日の曜日(数値)
      let firstDay = new Date(
        this.calData.year,
        this.calData.month - 1,
        1
      ).getDay();
      // 晦日の日にち
      let lastDate = new Date(
        this.calData.year,
        this.calData.month,
        0
      ).getDate();
      // 日にちのカウント
      let dayIdx = 1;
      //現在の時刻
      let dt = new Date("2021/12/01");
      let dtYear = 2021;
      let dtMonth = 12;
      let dtDay = 1;
      let currentLastDate = new Date(dtYear, dtMonth, 0).getDate();
      let current = +dtYear + "/" + dtMonth + "/" + dtDay;
      let currentDt = new Date(current);
      //今日の曜日（数値）
      let dayWeek = dt.getDay() + 1; //日曜日始まりのため+1をする
      let calendar = [];
      //予約のための変数
      let dif;
      let reserDate;
      //受取最短日時の計算
      for (
        let i = 0;
        i < this.reservation.store.acf["自社配送曜日"].length;
        i++
      ) {
        if (
          dayWeek < parseInt(this.reservation.store.acf["自社配送曜日"][i], 10)
        ) {
          dif = this.reservation.store.acf["自社配送曜日"][i] - dayWeek;
          reserDate = dtDay + dif; //日数（数値）
          break;
        }
      }
      if (isNaN(dif)) {
        dif =
          parseInt(this.reservation.store.acf["自社配送曜日"][0], 10) +
          7 -
          dayWeek;
        reserDate = dif + dtDay;
      }
      let reser;
      if (reserDate <= currentLastDate) {
        reser = dtYear + "/" + dtMonth + "/" + reserDate;
      } else {
        if (dtMonth === 12) {
          reser = dtYear + 1 + "/" + 1 + "/" + (reserDate - currentLastDate);
        } else {
          reser =
            dtYear + "/" + (dtMonth + 1) + "/" + (reserDate - currentLastDate);
        }
      }
      let reser_dt = new Date(reser);
      //カレンダー作成
      for (let w = 0; w < 6; w++) {
        let week = [];
        // 空白行をなくすため
        if (lastDate < dayIdx) {
          break;
        }
        for (let d = 0; d < 7; d++) {
          //カレンダーの日付
          let calDate =
            this.calData.year + "/" + this.calData.month + "/" + dayIdx;
          let calDateDt = new Date(calDate);
          //カレンダーが入らない部分
          if ((w == 0 && d < firstDay) || lastDate < dayIdx) {
            week[d] = {
              day: "",
              visited: true,
              today: false,
            };
          } else {
            //カレンダーが入る部分

            //今月
            if (this.calData.month === dtMonth) {
              //今日より前
              if (calDateDt.getTime() < dt.getTime()) {
                if (dtDay === dayIdx) {
                  week[d] = {
                    day: dayIdx,
                    visited: true,
                    today: true,
                  };
                } else {
                  week[d] = {
                    day: dayIdx,
                    visited: true,
                    today: false,
                  };
                }
              } else {
                // 店休日かどうか
                let openFlug = "";
                let openFlugMonth, openFlugDay;
                if (this.calData.month < 10) {
                  openFlugMonth = "0" + this.calData.month;
                } else {
                  openFlugMonth = this.calData.month;
                }
                if (dayIdx < 10) {
                  openFlugDay = "0" + dayIdx;
                } else {
                  openFlugDay = dayIdx;
                }
                eval(
                  "openFlug = this.reservation.store.opening_hours.open_time_date" +
                    openFlugMonth +
                    openFlugDay +
                    ";"
                );

                if (openFlug === "rest") {
                  week[d] = {
                    day: dayIdx,
                    visited: true,
                    today: false,
                  };
                } else {
                  week[d] = {
                    day: dayIdx,
                    visited: false,
                    today: false,
                  };
                }
              }
            } else {
              //来月以降の場合
              // 店休日かどうか
              let openFlug_next = "";
              let openFlugMonth_next, openFlugDay_next;
              if (this.calData.month < 10) {
                openFlugMonth_next = "0" + this.calData.month;
              } else {
                openFlugMonth_next = this.calData.month;
              }
              if (dayIdx < 10) {
                openFlugDay_next = "0" + dayIdx;
              } else {
                openFlugDay_next = dayIdx;
              }

              eval(
                "openFlug_next = this.reservation.store.opening_hours.open_time_date" +
                  openFlugMonth_next +
                  openFlugDay_next +
                  ";"
              );

              if (openFlug_next === "rest") {
                week[d] = {
                  day: dayIdx,
                  visited: true,
                  today: false,
                };
              } else if (dayIdx > dtDay) {
                // 来月以降で日付が超えている場合
                if (
                  this.calData.month === dtMonth + 1 ||
                  (this.calData.month === 1 && dtMonth === 12)
                ) {
                  // 来月の場合
                  week[d] = {
                    day: dayIdx,
                    visited: false,
                    today: false,
                  };
                } else {
                  // 再来月の場合
                  week[d] = {
                    day: dayIdx,
                    visited: true,
                    today: false,
                  };
                }
              } else {
                week[d] = {
                  day: dayIdx,
                  visited: false,
                  today: false,
                };
              }
            }
            dayIdx++;
          }
        }
        calendar.push(week);
      }

      console.log(calendar);
      return calendar;
    },
  },
};
</script>

<style scoped lang="scss">
#step2 {
  .step2 {
    &__text1 {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      color: #333333;
    }
  }
}
.reverse {
  text-align: center;
  .a {
    margin: auto;
    color: #000;
    text-align: center;
    /*      font-family: HiraKakuProN-W3;*/
    font-size: 14px;
    line-height: 2;
    text-align: center;
    color: #333333;
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
    i {
      margin-right: 3px;
    }
  }
  span {
    border-bottom: 1px #000 solid;
  }
}
#modal {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  overflow-y: scroll;
  &--whiteBlock {
    position: relative;
    top: 20vh;
    left: 0;
    right: 0;
    width: 50%;
    padding: 20px 0;
    margin: auto;
    background: #fff;
    z-index: 20;
    @media (max-width: 767.98px) {
      width: 90%;
      margin: auto;
      top: 100px;
    }
  }
  &--content {
    position: relative;
    @media (max-width: 767.98px) {
      margin-top: 30px;
    }
    .stopButton {
      position: absolute;
      top: 0;
      right: 5px;
      margin-top: 0;
      font-size: 40px;
      @media (max-width: 767.98px) {
        margin-top: -20px;
        right: 25px;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .selectDate {
      text-align: center;
      font-size: 24px;
      padding-top: 50px;
      span {
        display: block;
        font-size: 34px;
      }
    }
    .selectTime {
      // visibility: hidden;
      // height: 0;
      // overflow: hidden;
      text-align: center;
      @media (max-width: 767.98px) {
        margin-top: 40px;
      }
      &__select {
        width: 62px;
        height: 45px;
        border-radius: 3px;
        border: solid 1px #cccccc;
        &:hover {
          opacity: 0.7;
          cursor: pointer;
        }
        &_1 {
        }
        &_2 {
        }
      }
    }
  }
  .btn {
    text-align: center;
    display: block;
    margin: 30px auto 0;
    padding: 15px 0;
    background-color: #831f17;
    color: #fff;
    width: 80%;
    position: relative;
    @media (max-width: 767.98px) {
      margin-top: 60px;
    }
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
    i {
      color: #fff;
      text-align: right;
      position: absolute;
      right: 30px;
      top: 50%;
      margin-top: -0.5em;
    }
  }
}

/* カレンダー（大枠） */
.calendar {
  margin: auto;
  margin-top: 35px;
  table {
    margin: 30px auto;
    width: 100%;
  }
}

//buttonなど
#calendar-nav {
  p {
    position: relative;
    .currentMonth {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.1;
      text-align: center;
      color: #333333;
      width: 80%;
      @media (max-width: 767.98px) {
        font-size: 20px;
      }
    }
    .monthBtn {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: center;
      color: #ffffff;
      background-color: #0d446f;
      padding: 8px 12px;
      @media (max-width: 767.98px) {
        font-size: 10px;
        margin-top: -3px;
      }
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
      &_right {
        position: absolute;
        right: 20px;
        &:after {
          content: "";
          height: 0;
          width: 0;
          border: 19px solid transparent;
          border-left: 10px solid #0d446f;
          position: absolute;
          right: -29px;
          top: 50%;
          margin-top: -19px;
          @media (max-width: 767.98px) {
            border: 16px solid transparent;
            border-left: 10px solid #0d446f;
            position: absolute;
            right: -26px;
            top: 50%;
            margin-top: -16px;
          }
        }
      }
      &_left {
        position: absolute;
        left: 20px;
        &:after {
          content: "";
          height: 0;
          width: 0;
          border: 19px solid transparent;
          border-right: 10px solid #0d446f;
          position: absolute;
          left: -29px;
          top: 50%;
          margin-top: -19px;
          @media (max-width: 767.98px) {
            border: 16px solid transparent;
            border-right: 10px solid #0d446f;
            position: absolute;
            left: -26px;
            top: 50%;
            margin-top: -16px;
          }
        }
      }
    }
  }
}

/* カレンダーのスタイル */
th {
  font-weight: normal;
}
tr {
  text-align: center !important;
}
thead:after {
  content: "";
  height: 10px;
  width: 100%;
  padding: 5px 0;
  display: block;
}
tbody {
  td {
    text-align: right;
    padding: 0 5px 30px 20px;
    border: solid 1px #000;
    &:hover {
      opacity: 0.7;
      cursor: pointer;
      background-color: aliceblue;
    }
    .day {
    }
  }
}

//指定日のクラス
.visited {
  background-color: #eee !important;
  /* position: relative; */

  &:hover {
    opacity: 1;
    cursor: auto;
  }

  /* &::after {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    content: "×";
    font-size: 15px;
    color: red;
  } */
}
.today {
  border: solid 3px #0d446f !important;
  &:hover {
    opacity: 1;
    cursor: auto;
  }
}

// シティプラザ　休業のお知らせ
// .city_plaza_rest_info {
//   color: red;
//   font-size: 14px;
//   text-align: center;
//   font-weight: bold;
//   margin-bottom: 1rem;
// }
</style>
